module.exports = __webpack_public_path__ + "img/img_24.48b4af9c.png";